import React from 'react';
import _ from 'lodash';
import { contentfulModels, contentfulViews } from '@glowforge/ui-common';


import './meet-the-family.less';

const { widgetDefaultProps, widgetPropType } = contentfulModels;
const { getContentByType, getContentFieldsByType } = contentfulModels;
const { getWidget, Image } = contentfulViews;

/**
 * MeetTheFamily custom widget
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */
const MeetTheFamily = ({
  sections,
  model,
}) => {
  const title = _.get(model, 'textStrings.meet-the-family');
  const productsPageLink = _.get(model, 'textStrings.products-page-link');
  const buttonLinks = _.map(getContentByType(sections, 'buttonLink'), getWidget);

  // 2 images per product, stored as a list
  const products = getContentFieldsByType(sections, 'list');
  const productImages = _.map(products, (product) => {
    const logo = _.get(product, 'listItems[0].fields.media');
    const photo = _.get(product, 'listItems[1].fields.media');

    return (
      <a href={productsPageLink} className='product' key={_.get(product, 'id')}>
        <Image media={logo} className='product-logo' lazy />
        <Image media={photo} className='product-photo' lazy />
      </a>
    );
  });

  return (
    <div className='MeetTheFamily'>
      <h2 className='h2'>{title}</h2>
      <div className='ctaButtons'>{ buttonLinks }</div>
      <div className='products'>{productImages}</div>
    </div>
  );
};

MeetTheFamily.propTypes = { ...widgetPropType };

MeetTheFamily.defaultProps = { ...widgetDefaultProps };

export default MeetTheFamily;




// WEBPACK FOOTER //
// ./app/components/landing/meet-the-family.jsx